export const SALES_METHOD = {
  // Events (always on top)

  // Alphabetical order starts here
  BC_TELE: 'BC TELE',
  BC_WA_COMMUNITY: 'BC WA Community',
  CARI_BARANG: 'Cari Barang',
  CATALOG_IG: 'Catalog IG',
  CATALOG_WEB: 'Catalog Web',
  DEAL_OF_THE_WEEK: 'Deal of the Week',
  HOME_SHOPPING: 'Home Shopping',
  IG_CHANNEL: 'IG Channel',
  IG_CONTENT_RACK_CATALOG: 'IG Content - Catalogue di Rak',
  IG_CONTENT_REF_PICT: 'IG Content - Ref Pict',
  IG_CONTENT_STORE_PHOTO: 'IG Content - Foto di Toko',
  IG_CONTENT_TRY_ON: 'IG Content - Try On',
  IG_CONTENT_UNBOXING: 'IG Content - Unboxing',
  IG_STORY_WA_ME: 'IG Story - WA ME',
  OFFERING_OFFLINE: 'Tawarin Barang - Offline',
  OFFERING_ONLINE: 'Tawarin Barang - Online',
  PRIVATE_VIEWING: 'Private Viewing',
  STORY_CLASSIC: 'Story Classic',
  STORY_EXOTIC: 'Story Exotic',
  STORY_TELLING: 'Story Telling',
  WALK_IN: 'Walk In',
  WA_STORY: 'WA Story',
}

export const AUTHENTICATOR = {
  ENTRUPY : 'Entrupy',
  BABABEBI  : 'Bababebi',
  LEGIT_GRAILS  : 'Legit Grails',
  AUTHENTICATE_FIRST  : 'Authenticate First',
  REAL_AUTHENTICATION  : 'Real Authentication',
}

export const DEAL_STATE = {
  COMPLETED : 'completed',
  ON_DELIVERY : 'on_delivery',
  CANCELLED : 'cancelled',
  FAILED : 'failed',
  WAITING_FOR_CONFIRMATION : 'waiting_for_confirmation',
}

export const PAYMENT_METHOD = {
  MANUAL_TRANSFER : 'manual_transfer',
  CASH : 'cash',
  EDC : 'edc',
}